module.exports = __webpack_public_path__ + "static/bg-ayampe-sunrise-0feb169fc355725b298e168cd3883b2f.png";